import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../slices/CounterSlice";
import LayoutReducer from "../slices/LayoutSlice";
import GoogleLoaderReducer from "../slices/LoaderSlice"

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    layout : LayoutReducer,
    googleLoaderCheck : GoogleLoaderReducer,
  },
});